import "./styles/main.scss";

document.addEventListener("alpine:init", () => {
	Alpine.data("wp_block_d3_security_logo_fade", () => ({
		init() {
			//const $wrap = this.$el.querySelector(".wp-block-d3-security-logo-row-inner-blocks");
			const logoGrid = this.$el.querySelector('.logo-fade-grid');

// 1. Get image srcs from the hidden #logoSources div
			const allImgElements = this.$el.querySelectorAll('.wp-block-d3-security-logo-fade-inner-blocks .wp-block-d3-security-logo-fade-item img');
			const allLogos = Array.from(allImgElements).map(img => {
				const logo = document.createElement('img');
				logo.src = img.src;
				logo.alt = img.alt;
				logo.className = 'logo';
				return logo;
			});

			const visibleCount = 14;
			let visibleLogos = allLogos.slice(0, visibleCount);
			let hiddenLogos = allLogos.slice(visibleCount);

// 2. Add the first 14 to the grid (fixed position)
			visibleLogos.forEach(logo => logoGrid.appendChild(logo));

// 3. Swap one logo in place every few seconds
			function swapRandomLogo() {
				if (hiddenLogos.length === 0) return;

				const indexToReplace = Math.floor(Math.random() * visibleLogos.length);
				const currentLogo = visibleLogos[indexToReplace];
				const newLogo = hiddenLogos.shift(); // Take one from hidden
				hiddenLogos.push(currentLogo);       // Put current one into hidden

				newLogo.className = 'logo';
				newLogo.style.opacity = '0';

				// Fade out old logo
				currentLogo.style.opacity = '0';

				setTimeout(() => {
					// Replace element in grid
					logoGrid.replaceChild(newLogo, currentLogo);
					visibleLogos[indexToReplace] = newLogo;

					// Fade in new logo
					setTimeout(() => {
						newLogo.style.opacity = '1';
					}, 10);
				}, 1000);
			}

			setInterval(swapRandomLogo, 2000);


		},
	}));
});
